var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0802 15.0057L12.9197 17.4196V12.5801L17.0802 15.0057Z",
    fill: "url(#paint0_linear_2073_9989)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9085 9.35742H10.0914C9.69909 9.35742 9.31062 9.43473 8.94819 9.58492C8.58576 9.73511 8.25648 9.95525 7.97916 10.2328C7.70184 10.5103 7.48192 10.8397 7.33197 11.2022C7.18201 11.5647 7.10497 11.9533 7.10523 12.3456V17.6548C7.10497 18.0471 7.18201 18.4356 7.33197 18.7982C7.48192 19.1607 7.70184 19.4901 7.97916 19.7676C8.25648 20.0451 8.58576 20.2653 8.94819 20.4154C9.31062 20.5656 9.69909 20.6429 10.0914 20.6429H19.9085C20.3008 20.6429 20.6893 20.5656 21.0517 20.4154C21.4142 20.2653 21.7434 20.0451 22.0208 19.7676C22.2981 19.4901 22.518 19.1607 22.668 18.7982C22.8179 18.4356 22.895 18.0471 22.8947 17.6548V12.3456C22.895 11.9533 22.8179 11.5647 22.668 11.2022C22.518 10.8397 22.2981 10.5103 22.0208 10.2328C21.7434 9.95525 21.4142 9.73511 21.0517 9.58492C20.6893 9.43473 20.3008 9.35742 19.9085 9.35742ZM12.9197 17.4199V12.5804L17.0802 15.0002L12.9197 17.4199Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2073_9989",
    x1: 12.144,
    y1: 13.3557,
    x2: 15.4361,
    y2: 16.6498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B71C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B71C1C",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.fed65ea4e09b51bb07be3e473c404683.svg";
export { ForwardRef as ReactComponent };